import React from "react";
import {Pill, PillText} from "../../_layout/Pill";
import {ClaimStatuses} from "../../../types/travelClaims";

type StatusUi = {
    label: string;
    pillClass: string;
    textClass: string;
};

const STATUS_UI: Record<ClaimStatuses, StatusUi> = {
    IN_WORK: {
        label: "В работе",
        pillClass: "bg-[#f6f5c9]",
        textClass: "text-[#FCD700]",
    },
    FINISHED: {
        label: "Завершено",
        pillClass: "bg-statusapplicationbgcompleted",
        textClass: "text-statusapplicationtextcompleted",
    },
    ISSUED: {
        label: "Оформлено",
        pillClass: "bg-statusapplicationbgcompleted",
        textClass: "text-statusapplicationtextcompleted",
    },
    DRAFT: {
        label: "Черновик",
        pillClass: "bg-statusapplicationbgdraft",
        textClass: "text-statusapplicationtextdraft",
    },
    REGISTERED: {
        label: "Подтверждено",
        pillClass: "bg-statusapplicationbgissued",
        textClass: "text-statusapplicationtextissued",
    },
    // COORDINATING: {
    //     label: "На согласовании",
    //     pillClass: "bg-statusapplicationbgcoordination",
    //     textClass: "text-statusapplicationtextcoordination",
    // },
    // APPROVED: {
    //     label: "Утверждено",
    //     pillClass: "bg-statusapplicationbgapproved",
    //     textClass: "text-statusapplicationtextapproved",
    // },
    POSTPONED: {
        label: "Отложено",
        pillClass: "bg-statusapplicationbgdraft",
        textClass: "text-statusapplicationtextdraft",
    },
    NEW: {
        label: "Новая",
        pillClass: "bg-statusapplicationbgin-work",
        textClass: "text-statusapplicationtextin-work",
    },
    EXCHANGED: {
        label: "Обмен",
        pillClass: "bg-statusapplicationbgexchanged",
        textClass: "text-statusapplicationexchanged",
    },
    CANCELLED: {
        label: "Отмена",
        pillClass: "bg-statusapplicationbgcancelled",
        textClass: "text-statusapplicationcancelled",
    },
};

export const getClaimStatus = (status?: ClaimStatuses | null) => {
    const ui = status ? STATUS_UI[status] : undefined;
    if (!ui) {
        console.error("Unknown/empty claim status:", status);
        return status;
    }
    return (
        <Pill className={ui.pillClass}>
            <PillText className={ui.textClass}>{ui.label}</PillText>
        </Pill>
    );
};
